import cookieManager from "../../../../utils/cookieManager";
import axios from "axios";
import CashSalesActions from "../../../../reducers/modules/sales/cash-sales/actions";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Navigate } from "react-router-dom";

const MySwal = withReactContent(Swal);
const url = process.env.REST_URL + "sales/cash-sales";

export default class CashSalesMiddleware {

  static beforeVoid(data,search){
    return (dispatch) => {
      dispatch(CashSalesActions.beforeVoid(data));
      CashSalesMiddleware.void(dispatch,data,search);
    };
  }
  static void(dispatch, post, search){
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${CashSalesMiddleware.getToken()}`,
      },
      url: url+'/void',
      data: {idCash:post},
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            CashSalesActions.process(), CashSalesMiddleware.showlist(dispatch, search)
          );
          dispatch(CashSalesActions.success());
          CashSalesMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Void Reconcile Cash Sales Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        CashSalesMiddleware.alertHendler(dispatch, error, true);
      });
  }

  static showReconcile(data){
    return (dispatch) => {
      dispatch(CashSalesActions.showReconcile(data));
      CashSalesMiddleware.runShow(dispatch,data);
      CashSalesMiddleware.getHelperCashSales(dispatch);
    };
  }

  static getHelperCashSales(dispatch) {
   
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${CashSalesMiddleware.getToken()}`,
      },
      url: process.env.REST_URL+"helper/cash-sales",
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          console.log(response.data?.result)
          dispatch(
            CashSalesActions.setHelper(response.data?.result||{coaCashBank:[],coaExpense:[]}),
          );
          
        }
      })
      .catch((error) => {
        // CashSalesMiddleware.alertHendler(dispatch, error, true);
        dispatch(
        CashSalesActions.setHelper({coaCashBank:[],coaExpense:[]})
        )
      });
  } 

  static runShow(dispatch, data) {
  
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${CashSalesMiddleware.getToken()}`,
      },
      url: url + "/show",
      responseType: "json",
      params:{
        date:data.date,
        idSales:data.sales_id
      }
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            CashSalesActions.afterShowReconcile(response.data?.result||[]),
          );
          
        }
      })
      .catch((error) => {
        CashSalesMiddleware.alertHendler(dispatch, error, true);
      });
  } 
  static beforeSave(data,search){
    return (dispatch) => {
      dispatch(CashSalesActions.beforeSave());
      CashSalesMiddleware.save(dispatch,data,search);
    };
  }
  static save(dispatch, post, search){
    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${CashSalesMiddleware.getToken()}`,
      },
      url: url,
      data: post,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(
            CashSalesActions.process(), CashSalesMiddleware.showlist(dispatch, search)
          );
          dispatch(CashSalesActions.success());
          CashSalesMiddleware.alertHendler(
            dispatch,
            response,
            true,
            "Reconcile Cash Sales Successfully",
            "success"
          );
        }
      })
      .catch((error) => {
        CashSalesMiddleware.alertHendler(dispatch, error, true);
      });
  }
  static list(params) {
    return (dispatch) => {
      dispatch(CashSalesActions.process());
      CashSalesMiddleware.showlist(dispatch, params);
    };
  }
  static reset() {
    return (dispatch) => {
      dispatch(CashSalesActions.reset());
    };
  }
  
  static resetList() {
    return (dispatch) => {
      dispatch(CashSalesActions.resetList());
    };
  }


  
  static getOne(params) {
    return (dispatch) => {
      dispatch(CashSalesActions.view());
      CashSalesMiddleware.showOne(dispatch, params);
    };
  }








  static getToken() {
    return cookieManager.getUserToken();
  }


 
  static showlist(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${CashSalesMiddleware.getToken()}`,
      },
      url: url,
      responseType: "json",
      params: params,
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(CashSalesActions.list(response.data.result));
        }
      })
      .catch((error) => {
        CashSalesMiddleware.alertHendler(dispatch, error);
      });
  }


  static showOne(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${CashSalesMiddleware.getToken()}`,
      },
      url: url + "/" + params  ,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(CashSalesActions.view(response.data.result));
        }
      })
      .catch((error) => {
        CashSalesMiddleware.alertHendler(dispatch, error);
      });
  }

  static showOne(dispatch, params) {
    axios({
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${CashSalesMiddleware.getToken()}`,
      },
      url: url + "/" + params  ,
      responseType: "json",
    })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(CashSalesActions.view(response.data.result));
        }
      })
      .catch((error) => {
        CashSalesMiddleware.alertHendler(dispatch, error);
      });
  }

 



 

  static alertHendler(
    dispatch,
    result,
    isSwal = false,
    extraMessage = "",
    type = "error"
  ) {
    if (type == "error") {
      if (result.response) {
        const status = result.response.status;
        switch (status) {
          case 500:
            if (isSwal) {
              const data = result.response.data;
              MySwal.hideLoading();
              MySwal.update({
                title: "Prosess Error",
                html: data.error,
                icon: "error",
                showConfirmButton: true,
              });
              
            } else {
              const data = result.response.data;
            }
            dispatch(CashSalesActions.error([]));
            break;
          case 403:
            console.log("Error 403");
            dispatch(CashSalesActions.error([]));
            break;
          case 404:
            console.log("Error 404");
            dispatch(CashSalesActions.error([]));
            break;
          case 401:
            const data = result.response.data;
            MySwal.fire({
              title: "Login Invalid",
              html: data.error,
              icon: "error",
              showConfirmButton: true,
            }).then((result) => {
              if (result.isConfirmed) {
                <Navigate to="/login"></Navigate>;
              }
            });
            break;
        }
      } else if (result.request) {
        MySwal.fire({
          title: "Internal Server Error",
          html: "Please info your Developer to fix this",
          icon: "error",
          showConfirmButton: true,
        });
        dispatch(CashSalesActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", result.message);
      }
    } else {
      MySwal.fire({
        title: "Success",
        html: extraMessage,
        icon: "success",
        showConfirmButton: true,
      });
    }
  }
}
